import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { ChartLineUp, Bank, Wallet, ShieldCheck, GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const features = [
    { icon: ChartLineUp, title: "Anlık Nakit Akışı", desc: "Gelir ve giderlerinizi gerçek zamanlı izleyin." },
    { icon: Bank, title: "Banka & Cari", desc: "Tüm hesaplarınızı tek panelden yönetin." },
    { icon: Wallet, title: "Çek & Ödemeler", desc: "Yaklaşan ödemeleri ve çekleri kaçırmayın." },
  ];

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background" data-testid="login-page">
      <div className="relative hidden lg:flex flex-col justify-between p-12 border-r border-border noise-bg overflow-hidden">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px] -translate-x-1/3 -translate-y-1/3" />
        <div className="relative flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center">
            <ChartLineUp size={22} weight="bold" className="text-white" />
          </div>
          <span className="font-display text-xl font-semibold">Kasa<span className="text-primary">Flow</span></span>
        </div>
        <div className="relative space-y-8 max-w-md">
          <h1 className="text-4xl xl:text-5xl font-semibold leading-[1.1]">
            Finansınızı tek bir yerden <span className="text-primary">kontrol edin.</span>
          </h1>
          <p className="text-muted-foreground text-lg">
            Gelir, gider, banka, cari hesap, çek ve tahsilatlarınızı yönetin. Yapay zeka destekli nakit akışı analizi.
          </p>
          <div className="space-y-4 pt-4">
            {features.map((f, i) => (
              <div key={i} className="flex items-start gap-4 fade-up" style={{ animationDelay: `${i * 100}ms` }}>
                <div className="w-10 h-10 rounded-md bg-card border border-border flex items-center justify-center shrink-0">
                  <f.icon size={20} className="text-primary" />
                </div>
                <div>
                  <p className="font-medium">{f.title}</p>
                  <p className="text-sm text-muted-foreground">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative flex items-center gap-2 text-sm text-muted-foreground">
          <ShieldCheck size={16} /> Verileriniz güvende ve şifrelenmiş.
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm space-y-8 fade-up">
          <div className="lg:hidden flex items-center gap-3 justify-center">
            <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center">
              <ChartLineUp size={22} weight="bold" className="text-white" />
            </div>
            <span className="font-display text-xl font-semibold">KasaFlow</span>
          </div>
          <div className="space-y-2">
            <h2 className="font-display text-3xl font-semibold">Hoş geldiniz</h2>
            <p className="text-muted-foreground">Devam etmek için Google hesabınızla giriş yapın.</p>
          </div>
          <Button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="w-full h-12 text-base gap-3 bg-white text-black hover:bg-white/90 transition-colors duration-200"
          >
            <GoogleLogo size={22} weight="bold" /> Google ile Giriş Yap
          </Button>
          <p className="text-xs text-muted-foreground text-center">
            Giriş yaparak kullanım koşullarını kabul etmiş olursunuz.
          </p>
        </div>
      </div>
    </div>
  );
}
